import './bootstrap'
import './scripts' // mostly jquery scripts
import './mixins' // vue mixins
import './extends' // code that extends functionality of other libraries
import './directives' // vue directives
import './filters' // vue filters
import store from './vuex'

import SvgVue from 'svg-vue'
import VCalendar from 'v-calendar'
import '@core/VueComponentRegister' // automatic components register
import './vue-component-register.js' // manual components register

Vue.use(SvgVue)

Vue.use(VCalendar, {
    screens: {
        xxl: '1536px'
    }
})

import './app/index.js' // application scripts
import './scripts/forum.js'

new Vue({
    el: '#app',
    store,
    data: {
        storeCompleted: false,
        tab: null
    },
    async mounted() {
        console.log(`
        ----------------------------------------
        ----------------Vitad.io----------------
        ----------------------------------------
            ${moment().format('Do MMMM YYYY, HH:mm:ss')}
    `)

        // Try to store currently logged in user into the store
        await store.commit('general/setUser')

        this.storeCompleted = true
    }
})
